// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chats section Start */
#wps_rma_order_msg_react .wps_order_msg_container {
    max-width: calc(100% - 30px);
    width: 100%;
    margin: auto;
}

.wps_order_msg_sub_container::-webkit-scrollbar {
    width: 8px;
}
  
.wps_order_msg_sub_container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}
  
.wps_order_msg_sub_container::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}
  
.wps_order_msg_sub_container::-webkit-scrollbar-thumb:hover {
    background: #555; 
}

.wps_order_msg_sub_container {
    padding: 25px;
    background: #fff;
    border-radius: 0 0 5px 5px;
    max-height: 400px;
    overflow: auto;
    border: 1px solid #c2c2c2;
    border-top: none;
}

.wps_order_msg_sub_container .wps-order-msg_row {
    margin: 0 0 15px;
}

.wps_order_msg_sub_container .wps-order-msg_row_customer {
    text-align: right;
}

.wmb-order-customer__msg-container {
    text-align: right;
}

.wps-order-msg_row_shopmanager .wps_order_msg_detail_container {
    padding: 10px;
    background: #5481b3;
    border-radius: 10px 10px 10px 0;
    max-width: 400px;
    display: inline-block;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    color: #fff;
}

.wps-order-msg_row_customer .wps_order_msg_detail_container {
    padding: 10px;
    background: #54b36f;
    border-radius: 10px 10px 0 10px;
    max-width: 55%;
    margin: 0 0 0 auto;
    display: inline-block;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    color: #fff;
}

.wps_order_msg_sender_details {
    font-size: 14px;
    font-weight: 600;
    display: flex;
    gap: 0;
    line-height: 1.25;
    flex-direction: column;
}

.wmb-order-customer__msg-container .wps_order_msg_sender_details {
    justify-content: flex-end;
}

.wps_order_msg_main_container {
    margin: 0 0 5px;
}

.wps_order_msg_sender_details .wps_order_msg_date {
    font-size: 10px;
    font-weight: 400;
}

.wps_order_msg_single_attachment img {
    max-width: 100px;
    aspect-ratio: 1;
    object-fit: contain;
    border: 1px solid #e2e2e2;
}

.wps_order_msg_single_attachment .wps_order_msg_attachment_file_name {
    display: none;
}

.wps_order_msg_attach_container {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.wps_order_msg_sub_container .wps-order-msg_row_customer .wps_order_msg_attach_container {
    justify-content: flex-end;
    margin: 15px 0 0;
}

.wps_order_msg_att-wrap {
    background: transparent;
    display: inline-flex;
    position: relative;
}

.wps_order_msg_att-wrap svg {
    width: 28px;
    height: 28px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.wps_order_msg_att-wrap.not_active svg path {
    stroke: #ccc;
}
.wps_order_msg_att-wrap.active svg path {
    stroke: #000000;
}

.wps_order_msg_att-wrap #wps_order_msg_attachment {
    opacity: 0;
    width: 28px;
    position: relative;
    margin: 0;
}

.wps-order-msg-attachment-wrapper {
    cursor: pointer;
}

.wps_order_msg_att-wrap input:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: pointer;
    z-index: 1;
}

.wps-rma-order-msg-wrapper {
    display: flex;
    gap: 10px;
    margin: 15px 0 0;
}

.wps-rma-order-msg-wrapper #wps_order_new_msg {
    min-height: auto;
    max-height: 83px;
    font-size: 14px;
    line-height: 1.5;
    background: transparent;
    box-shadow: none;
    border: 1px solid #c2c2c2;
    resize: none;
    border-radius: 5px;
    width: 100%;
    height: auto;
    margin: 0;
    padding: 5px;
}

.wps-rma-order-msg-wrapper .wps-order-msg-attachment-wrapper {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    flex-direction: column;
}

.wps-order-msg-btn svg {
    width: 28px;
    height: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
}

.wps-order-msg-btn input {
    width: 28px;
    height: 28px;
    padding: 0;
    opacity: 0;
    position: relative;
    z-index: 1;
    cursor: pointer;
    min-height: auto;
    margin: 0;
}

.wps-order-msg-btn {
    position: relative;
    cursor: pointer;
    background: #54b36f;
    padding: 5px;
    border-radius: 5px;
    flex: 1;
}

.wps-order-msg-btn svg path {
    stroke: #fff;
}

.wps_o_m-label-wrap label {
    font-size: 12px;
    text-align: right;
    display: block;
    margin: 5px 0 15px;
}

#wps_rma_notification_div label {
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 5px;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
}

#wps_rma_notification_div label input[type=tel] {
    background: transparent;
    box-shadow: none;
    border: 1px solid  #c2c2c2;
    border-radius: 5px;
    font-size: 14px;
    line-height: 1.25;
    min-height: 33px;
    padding: 10px;
}

#wps_rma_notification_div .wps_rma_notification_label {
    font-size: 12px;
    margin: 5px 0 0;
}

#wps_rma_notification_div {
    text-align: center;
    margin: 15px auto;
    max-width: 400px;
}

#wps_rma_notification_div label input[type=tel]:focus,.wps-order-msg-btn input:focus,.wps-rma-order-msg-wrapper #wps_order_new_msg:focus {
    outline: none;
}

.wps-order-msg_column {
    display: flex;
    justify-content: space-between;
    padding: 5px 10px;
    background: #f2f2f2;
    color: #098046;
    border-radius: 5px 5px 0 0;
    font-size: 18px;
    border: 1px solid #c2c2c2;
}

.wps-order-msg_column .shop_man-title {
    color: #2b4473;
}

/* Chats section End */`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,4BAA4B;IAC5B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,gBAAgB;IAChB,qBAAqB;IACrB,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,MAAM;IACN,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,eAAe;IACf,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA,sBAAsB","sourcesContent":["/* Chats section Start */\n#wps_rma_order_msg_react .wps_order_msg_container {\n    max-width: calc(100% - 30px);\n    width: 100%;\n    margin: auto;\n}\n\n.wps_order_msg_sub_container::-webkit-scrollbar {\n    width: 8px;\n}\n  \n.wps_order_msg_sub_container::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 10px;\n}\n  \n.wps_order_msg_sub_container::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 10px;\n}\n  \n.wps_order_msg_sub_container::-webkit-scrollbar-thumb:hover {\n    background: #555; \n}\n\n.wps_order_msg_sub_container {\n    padding: 25px;\n    background: #fff;\n    border-radius: 0 0 5px 5px;\n    max-height: 400px;\n    overflow: auto;\n    border: 1px solid #c2c2c2;\n    border-top: none;\n}\n\n.wps_order_msg_sub_container .wps-order-msg_row {\n    margin: 0 0 15px;\n}\n\n.wps_order_msg_sub_container .wps-order-msg_row_customer {\n    text-align: right;\n}\n\n.wmb-order-customer__msg-container {\n    text-align: right;\n}\n\n.wps-order-msg_row_shopmanager .wps_order_msg_detail_container {\n    padding: 10px;\n    background: #5481b3;\n    border-radius: 10px 10px 10px 0;\n    max-width: 400px;\n    display: inline-block;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    color: #fff;\n}\n\n.wps-order-msg_row_customer .wps_order_msg_detail_container {\n    padding: 10px;\n    background: #54b36f;\n    border-radius: 10px 10px 0 10px;\n    max-width: 55%;\n    margin: 0 0 0 auto;\n    display: inline-block;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n    color: #fff;\n}\n\n.wps_order_msg_sender_details {\n    font-size: 14px;\n    font-weight: 600;\n    display: flex;\n    gap: 0;\n    line-height: 1.25;\n    flex-direction: column;\n}\n\n.wmb-order-customer__msg-container .wps_order_msg_sender_details {\n    justify-content: flex-end;\n}\n\n.wps_order_msg_main_container {\n    margin: 0 0 5px;\n}\n\n.wps_order_msg_sender_details .wps_order_msg_date {\n    font-size: 10px;\n    font-weight: 400;\n}\n\n.wps_order_msg_single_attachment img {\n    max-width: 100px;\n    aspect-ratio: 1;\n    object-fit: contain;\n    border: 1px solid #e2e2e2;\n}\n\n.wps_order_msg_single_attachment .wps_order_msg_attachment_file_name {\n    display: none;\n}\n\n.wps_order_msg_attach_container {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.wps_order_msg_sub_container .wps-order-msg_row_customer .wps_order_msg_attach_container {\n    justify-content: flex-end;\n    margin: 15px 0 0;\n}\n\n.wps_order_msg_att-wrap {\n    background: transparent;\n    display: inline-flex;\n    position: relative;\n}\n\n.wps_order_msg_att-wrap svg {\n    width: 28px;\n    height: 28px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.wps_order_msg_att-wrap.not_active svg path {\n    stroke: #ccc;\n}\n.wps_order_msg_att-wrap.active svg path {\n    stroke: #000000;\n}\n\n.wps_order_msg_att-wrap #wps_order_msg_attachment {\n    opacity: 0;\n    width: 28px;\n    position: relative;\n    margin: 0;\n}\n\n.wps-order-msg-attachment-wrapper {\n    cursor: pointer;\n}\n\n.wps_order_msg_att-wrap input:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    cursor: pointer;\n    z-index: 1;\n}\n\n.wps-rma-order-msg-wrapper {\n    display: flex;\n    gap: 10px;\n    margin: 15px 0 0;\n}\n\n.wps-rma-order-msg-wrapper #wps_order_new_msg {\n    min-height: auto;\n    max-height: 83px;\n    font-size: 14px;\n    line-height: 1.5;\n    background: transparent;\n    box-shadow: none;\n    border: 1px solid #c2c2c2;\n    resize: none;\n    border-radius: 5px;\n    width: 100%;\n    height: auto;\n    margin: 0;\n    padding: 5px;\n}\n\n.wps-rma-order-msg-wrapper .wps-order-msg-attachment-wrapper {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    flex-direction: column;\n}\n\n.wps-order-msg-btn svg {\n    width: 28px;\n    height: auto;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%,-50%);\n}\n\n.wps-order-msg-btn input {\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    opacity: 0;\n    position: relative;\n    z-index: 1;\n    cursor: pointer;\n    min-height: auto;\n    margin: 0;\n}\n\n.wps-order-msg-btn {\n    position: relative;\n    cursor: pointer;\n    background: #54b36f;\n    padding: 5px;\n    border-radius: 5px;\n    flex: 1;\n}\n\n.wps-order-msg-btn svg path {\n    stroke: #fff;\n}\n\n.wps_o_m-label-wrap label {\n    font-size: 12px;\n    text-align: right;\n    display: block;\n    margin: 5px 0 15px;\n}\n\n#wps_rma_notification_div label {\n    font-size: 16px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    flex-wrap: wrap;\n    justify-content: center;\n    flex-direction: column;\n}\n\n#wps_rma_notification_div label input[type=tel] {\n    background: transparent;\n    box-shadow: none;\n    border: 1px solid  #c2c2c2;\n    border-radius: 5px;\n    font-size: 14px;\n    line-height: 1.25;\n    min-height: 33px;\n    padding: 10px;\n}\n\n#wps_rma_notification_div .wps_rma_notification_label {\n    font-size: 12px;\n    margin: 5px 0 0;\n}\n\n#wps_rma_notification_div {\n    text-align: center;\n    margin: 15px auto;\n    max-width: 400px;\n}\n\n#wps_rma_notification_div label input[type=tel]:focus,.wps-order-msg-btn input:focus,.wps-rma-order-msg-wrapper #wps_order_new_msg:focus {\n    outline: none;\n}\n\n.wps-order-msg_column {\n    display: flex;\n    justify-content: space-between;\n    padding: 5px 10px;\n    background: #f2f2f2;\n    color: #098046;\n    border-radius: 5px 5px 0 0;\n    font-size: 18px;\n    border: 1px solid #c2c2c2;\n}\n\n.wps-order-msg_column .shop_man-title {\n    color: #2b4473;\n}\n\n/* Chats section End */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
